import React from 'react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';

import { PhoneNumber, Usage } from '../../types';

type UsageTableProps = {
  usageList: Usage[];
  loading: boolean;
};

const UsageTable = ({ usageList, loading }: UsageTableProps) => {
  const columns: ColumnsType<Usage> = [
    {
      title: 'WABA ID',
      dataIndex: 'wabaId',
      key: 'wabaId',
    },
    {
      title: 'WABA Name',
      align: 'center',
      dataIndex: 'wabaName',
      key: 'wabaName',
    },
    {
      title: 'Owner Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Partner Email',
      dataIndex: 'partnerEmail',
      key: 'partnerEmail',
    },
    {
      title: 'Phone Numbers',
      dataIndex: 'phoneNumbers',
      key: 'phoneNumbers',
      render: function PhoneNumber(phoneNumbers: PhoneNumber[]) {
        return phoneNumbers.map((num) => {
          return (
            <div key={num.id}>
              <span>{num.value}</span>
            </div>
          );
        });
      },
    },
    {
      title: 'Total Cost',
      align: 'center',
      dataIndex: 'totalCost',
      key: 'totalCost',
    },
    {
      title: 'Total Free Tier',
      align: 'center',
      dataIndex: 'FREE_TIER',
      key: 'FREE_TIER',
    },
    {
      title: 'Total Free Entry Point',
      align: 'center',
      dataIndex: 'FREE_ENTRY',
      key: 'FREE_ENTRY',
    },
    {
      title: 'Total Paid (Business Initiated)',
      align: 'center',
      dataIndex: 'PAID_BUSINESS',
      key: 'PAID_BUSINESS',
    },
    {
      title: 'Total Paid (User Initiated',
      align: 'center',
      dataIndex: 'PAID_USER',
      key: 'PAID_USER',
    },
  ];
  return (
    <Table
      loading={loading}
      columns={columns}
      dataSource={usageList.map((x) => {
        return {
          ...x,
          key: x.wabaId,
        };
      })}
      bordered
      pagination={false}
      scroll={{ x: true }}
    />
  );
};

export default UsageTable;
